import React from "react";
import { Box } from "@mui/material";
import PropTypes from "prop-types";
import Tab from "@mui/material/Tab";
import { tabs } from "./Dashboards/monitoringDashboardConfirg";
import { StyledMainBox, StyledTabs } from "../../components/commonComponents/StyledComponents/styled";
import AccessControl from "../../components/commonComponents/Hoc/AccessControl";
import { findMinSelectableDate, loadStorePeriods, loadStores } from "../../api_calls/campaigns";
import { useDispatch, useSelector } from "react-redux";
import { updateStateData, deleteItems } from "../../Store/actions";
import { setBatchLoadingStatus } from "../../api_calls/requestConfig";

// to load tab content
function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 0 }}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const Monitoring = () => {
  const userStateDetails = useSelector((state) => state.userSelections);
  const dispatchAction = useDispatch();
  const [value, setValue] = React.useState(0);
  const tabsConfig = tabs();

  const handleChange = (event, newValue) => {

    setValue(newValue);
    dispatchAction(
      updateStateData({
        monitoring_active_tab: newValue,
      })
    );
  };


  React.useEffect(() => {
    let isMounted = true;

    setBatchLoadingStatus(true);

    const loadMonitoringStores = async () => {
      try {
        const [storesResponse, periodsResponse] = await Promise.all([
          // Preload for the embeddable monitoring store dropdowns. Include the selected retailer.
          loadStores(undefined, { applyRetailerView: true }),
          loadStorePeriods("receipt-monitoring"),
        ]);

        if (isMounted && storesResponse.success === true && periodsResponse.success === true) {
          const storeNames = periodsResponse.store_dates.map((storeDetail) => storeDetail.name);
          findMinSelectableDate(storeNames);
        }
      } finally {
        if (isMounted) {
          setBatchLoadingStatus(false);
        }
      }
    };

    loadMonitoringStores();

    // Resetting store dates when the component unmounts
    return () => {
      isMounted = false;
      dispatchAction(deleteItems(["store_dates"]));
    };
  }, [dispatchAction]);

  return (
    <StyledMainBox component="main">
      {typeof userStateDetails.stores_list !== "undefined" &&
        typeof userStateDetails.store_dates !== "undefined" && (
        <>
          <Box
            sx={{
              display: "flex", // Make the Box a flex container
              borderBottom: 1,
              borderColor: "divider",
              position: "sticky",
              top: "0",
              zIndex: 999,
              backgroundColor: "#fff",
            }}
          >
            <Box component={"div"}>
              <StyledTabs value={value} onChange={handleChange} aria-label="brand analytics" textColor={"#F04B55"}>
                {tabsConfig.map((tabDetail) => {
                  return <Tab key={tabDetail.unique_key} icon={tabDetail.icon} label={tabDetail.label} {...a11yProps(0)} />;
                })}
              </StyledTabs>
            </Box>
            {/* ----------- filters section ------------ */}
            {
              window.screen.width > 1300 && (
                <Box
                  component={"div"}
                  sx={{
                    flex: 1,
                  }}
                >
                  {tabsConfig[value].filter_component}
                </Box>
              )
            }

          </Box>

          {/* ----------- filters section ------------ */}
          {
            window.screen.width < 1300 && (
              <Box
                sx={{
                  display: "flex", // Make the Box a flex container
                  // borderBottom: 1,
                  // borderColor: "divider",
                  position: "sticky",
                  flexWrap: "wrap",
                  top: 45,
                  zIndex: 999,
                  backgroundColor: "#fff",
                }}
              >
                <Box
                  component={"div"}
                  width={600}
                  sx={{
                    flex: 1,
                  }}
                >
                  {tabsConfig[value].filter_component}
                </Box>
              </Box>
            )
          }

          {/* ============== tab contents =========== */}
          {tabsConfig.map((tabDetail, index) => {
            return (
              <CustomTabPanel value={value} index={index}>
                {tabDetail.dashboard}
              </CustomTabPanel>
            );
          })}
        </>
      )}
    </StyledMainBox>
  );
};

export default AccessControl(Monitoring, ["infra_store_monitoring_can_view"], [], ["infrastructure_section", "monitoring_infra"]);
